import PropTypes from "prop-types";
import { Subtitle } from "components/atoms/Text";

const ServiceCard = ({ icons, title, description }, props) => {
    return (
        <div className="w-full p-8 desktop:p-[25px] desktop:py-[32px] phone:px-[32px] tablet:p-5 phone:py-8 rounded-lg bg-neutral-10">
            <div className="w-full phone:h-[160px] h-[160px] tablet:h-[150px] flex items-center justify-center tablet:p-6 p-[14px] bg-primary-surface mx-auto rounded-lg mb-8 tablet:mb-6">
                <img src={`/images/datacenter/service/${icons}.svg`} {...props} className="" alt={icons} />
            </div>
            <h1 className="font-semibold text-heading-5 tablet:text-heading-6 text-neutral-100 text-center leading-[36px]">{title}</h1>
            <Subtitle classNames="mt-3 tablet:mt-2 text-center !text-[14px] !leading-[23.8px]">{description}</Subtitle>
        </div>
    );
};

ServiceCard.propTypes = {
    icons: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default ServiceCard;